import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {RepositoryLabelIndexPageQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryLabelIndexPageQuery'
import {issuesAppBuilder} from '../config/app-builder'

// need this type to expose the errors array so we can detect FORBIDDEN
export type LabelsPayload = RepositoryDataResponse<RepositoryLabelIndexPageQueryQuery>

export const labelsRoute = issuesAppBuilder.createQueryRouteConfig('labelsRoute', {
  path: '/:owner/:repo/labels',
  queries: [
    mainQuery<LabelsPayload>({
      queryDeps: ({pathname, searchParams}) => ({
        pathname,
        searchParams: {
          page: searchParams.get('page') || '1',
          sort: searchParams.get('sort') || 'name-asc',
          ...(searchParams.get('q') ? {q: searchParams.get('q') || ''} : {}),
        },
      }),
    }),
  ],
})
